<template>
  <div id="mainLayout">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  mounted() {},
  methods: {},
}
</script>
<style scoped lang="less">
#mainLayout {
  height: 100%;
}
</style>
